import { render, staticRenderFns } from "./SuccessResponseIcon.vue?vue&type=template&id=680ccb54&scoped=true"
import script from "./SuccessResponseIcon.vue?vue&type=script&lang=js"
export * from "./SuccessResponseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ccb54",
  null
  
)

export default component.exports